<template>
    <div>
        <new-editor v-bind:config="config"></new-editor>
    </div>
</template>

<script>
    import axios from "axios";
    import NewEditor from "./newEditor";

    export default {
        name: "partauth",
        components: {NewEditor},
        data: function () {
            return {
                baseUrl: config.baseUrl,
                config: {
                    type: "",
                    width: '100%',
                    height: window.innerHeight,
                    documentType: "",
                    token: "",
                    document: {
                        title: "",
                        url: "",
                        fileType: "",
                        key: "",
                        info: {
                            author: "我",
                            created: ""
                        },
                        permissions: {
                            comment: true,
                            edit: true,
                            review: true,
                            modifyFilter: true,
                            download: true,
                            print: true,
                            copyoutenabled: true,
                            showReview: true,
                            partauth: {
                                "owner": {//文档所有人
                                    "userId": "",//用户ID
                                    "userName": "",//用户名称
                                    "userColor": ""//代表用户的颜色
                                },
                                "users":[{//待分配的用户信息，在权限设置模式下此项有效
                                    "userId": "",//用户ID
                                    "userName": "",//用户名称
                                    "userColor": ""//代表用户的颜色
                                }],
                                "isManager":false,
                                "canLockStyle":true,
                                "canUnLockStyle":false,
                                "isStyleLock":false,
                                "authlist": [{
                                    "partId":"",//区域ID，对应文字处理模块是内容域ID,对应电子表格模块是表格区域('Sheet1!C1:D1')

                                    "users": [{//对此区域设置过权限的用户列表
                                        "userId": "uid-5",//用户ID
                                        "userName": "testuser5",//用户名称
                                        "userColor": "red",//代表用户的颜色
                                        "auth": "",//被授予的区域权限,view只读（默认值）,edit为可编辑
                                        "confertime": "0"//授予权限的时间
                                    }],

                                    "canView":true,//是否隐藏
                                    "canEdit":true,//是否编辑
                                    "canAddBlock":true,//添加富内容域
                                    "canAddInline": true,//添加纯文本
                                    "canCut":true,//可以剪贴
                                    "canDelete":false,//子内容域可以删除
                                    "canDeleteCurrent":false,//当前内容域可以删除
                                    "canSetting":true,//设置内容域
                                    "canCopy":true,//拷贝
                                    "canComment":true,//批注
                                    "canSetPermission":true//权限设置
                                }]
                            },

                        },
                    },
                    editorConfig: {
                        mode: "edit",
                        callbackUrl: "",
                        user: {
                            "id": "uid-5",
                            "name": "testuser5",
                        },
                        embedded: {
                            saveUrl: "",
                            embedUrl: "",
                            shareUrl: "",
                            toolbarDocked: "top",
                        },
                        customization: {
                            about: true,
                            chat: false,
                            comments: true,
                            zoom: 100,
                            leftMenu: true,
                            rightMenu: true,
                            toolbar: true,
                            header: true,
                            statusBar: true,
                            autosave: true,
                            forcesave: true,
                            displayTitle: true,
                            goback: "",
                            reviewDisplay: 'markup',
                        },
                        limitEditMode: 'ctctrl',
                        lang: 'zh',
                    },
                },
            }
        },
        created() {
            var partauthMode = this.$route.query.partauthMode;
            this.config.document.permissions.partauth.owner.userId = this.$route.query.userid;
            this.config.document.permissions.partauth.owner.userName = this.$route.query.name;
            this.config.document.permissions.partauth.authlist[0].partId = this.$route.query.partId || '';
            this.config.document.permissions.partauth.authlist[0].canView = partauthMode !== 'hide';
            this.config.document.permissions.partauth.authlist[0].canEdit = partauthMode === 'edit';
            this.config.document.permissions.partauth.authlist[0].users[0].auth = partauthMode;

            var data = {
                // fileExt: fileExt,
                // sample: sample,
                mode: 'edit',
                fileName: this.$route.query.fileName,
                userid: this.$route.query.userid,
                name: this.$route.query.name,
                // lang: lang,
                // type: type,
                // leftMenu: leftMenu,
                // rightMenu: rightMenu,
                // statusBar: statusBar,
                // header: header,
                // toolbar: toolbar,
                // download: download,
                // print: print,
                // copyoutenabled: copyoutenabled,
            }
            // log("提交的data", data)
            // 获取 editor config 参数
            axios.post(this.baseUrl + '/editor', data).then(r => {
                var d = r.data;
                // console.log("返回的data", d)
                this.cleanData(d);
            })
        },
        methods: {
            cleanData: function(data) {
                // modify on 2020-11-3 填充编辑器参数
                // this.config.type = data.editor.type;
                this.config.documentType = data.editor.documentType;
                this.config.token = data.editor.token;
                this.config.document.title = data.file.name;
                this.config.document.url = data.file.uri;
                this.config.document.fileType = data.file.ext;
                this.config.document.key = data.editor.key;
                this.config.document.info.created = data.file.created;
                // this.config.document.permissions.comment = data.editor.comment;
                // this.config.document.permissions.review = data.editor.review;
                // this.config.document.permissions.edit = data.editor.edit;       // 修订,批注,只读 为 false
                // this.config.document.permissions.modifyFilter = data.editor.modifyFilter;
                // this.config.document.permissions.download = data.editor.download;
                // this.config.document.permissions.print = data.editor.print;
                // this.config.document.permissions.copyoutenabled = data.editor.copyoutenabled;
                // this.config.editorConfig.mode = data.editor.mode;               // 只读模式（view）| 编辑模式（edit）
                this.config.editorConfig.callbackUrl = data.editor.callbackUrl;
                // this.config.editorConfig.user.id = data.editor.userid;
                // this.config.editorConfig.user.name = data.editor.name;
                this.config.editorConfig.embedded.saveUrl = data.file.uri;
                this.config.editorConfig.embedded.embedUrl = data.file.uri;
                this.config.editorConfig.embedded.shareUrl = data.file.uri;
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/partauth.vue